document.addEventListener("DOMContentLoaded", () => {

  const MAX_HISTORY = 5;
  let historyQueue = [];

  // --- Helpers ---
  function setHistory(newProductId) {
    if (!newProductId) return;

    // Remove duplicates
    historyQueue = historyQueue.filter(id => id !== newProductId);
    console.log(historyQueue);
    // Add to front
    historyQueue.unshift(newProductId);
    console.log(historyQueue);
    // Limit size
    if (historyQueue.length > MAX_HISTORY) {
      historyQueue.pop();
    }
    console.log(historyQueue);
    // Persist
    localStorage.setItem("productHistory", JSON.stringify(historyQueue));
  }

  function loadHistory() {
    const stored = localStorage.getItem("productHistory");
    if (stored) {
      try {
        historyQueue = JSON.parse(stored);
      } catch {
        historyQueue = [];
      }
    }
  }

  function buildUrl(baseUrl, productId) {
    const url = new URL(baseUrl, window.location.origin);
    url.searchParams.set("product_id", productId);
    return url.toString();
  }

  // --- Intersection Observer ---
  const productRecommendationsSection = document.querySelector(
    ".History_Products_Section"
  );

  if (productRecommendationsSection) {
    const baseUrl = productRecommendationsSection.dataset.url;
    const baseId = productRecommendationsSection.dataset.url.split("product_id=")[1];

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);

      loadHistory(); // load stored queue

      historyQueue.forEach(productId => {
        console.log(baseId, productId);
        if(baseId != productId){
          const url = buildUrl(baseUrl, productId);

          fetch(url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement("div");
              html.innerHTML = text;

              const historyCard = html.querySelector(".Related_Product");
              const target = productRecommendationsSection.querySelector(
                ".Related_Products"
              );

              if (historyCard && target) {
                target.appendChild(historyCard);
                historyCard.classList.remove("visually-hidden");
                if (typeof publish !== "undefined") {
                  publish(PUB_SUB_EVENTS.contentAdded, { content: historyCard });
                }
              }
            })
            .catch(console.error);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 200px 0px",
    });

    observer.observe(productRecommendationsSection);
  }

  loadHistory();

  // --- Detect current product from attribute ---
  const productEl = document.querySelector("[product-history]");
  if (productEl) {
    const currentProductId = productEl.getAttribute("product-history");
    if (currentProductId) {
      setHistory(currentProductId);
    }
  }
});